import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRequest } from '../hooks/UseRequest';
import { useLocation, useParams } from 'react-router-dom';
import { selectModules } from '../redux/moduleSlice';
import { selectAuth } from '../redux/authSlice';
import { setNotification } from '../redux/notificationSlice';

export default function UserPageViewAudit() {
  const requests = useRequest();
  const modules = useSelector(selectModules);
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const [moduleId, setModuleId] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [recordId, setRecordId] = useState(null);
  const [route, setRoute] = useState(null);

  useEffect(() => {
    const handleBeforeUnload = async (event) => {
      // Only when Agent closing tab or reload page then using fetch and keepAlive to post tracking data
      await fetch(`${process.env.REACT_APP_API_DOMAIN}/user_page_view`, {
        keepalive: true,
        method: 'POST',
        headers: {
           'Content-Type': 'application/json',
           Accept: 'application/json',
           Authorization: `Bearer ${auth.accessToken}`
        },
        body: JSON.stringify(getDataPost()),
      });
    };

    if (moduleId) {
       // Add event listener for beforeunload
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    // Return cleanup function: remove previous event unload when module id or record id changed
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [moduleId, recordId]);

  useEffect(() => {
    //initial onload set module id is null
    setModuleId(null)
  }, [])

  useEffect(() => {
    handlePageView(location.pathname);
  }, [location.pathname, auth.accessToken, modules]);

  const handlePageView = (pathname) => {
    if (auth.accessToken && modules?.status === 'succeeded') {
       try {
        if (moduleId && route !== pathname) {
          sendPageViewAudit();
        }
       } catch (err) {
          dispatch(setNotification({ type: 'error', body: `Error: ${err.status}` }));
       }

      if (moduleId === null || route !== pathname) {
        const moduleKey = getModuleKey();
        const module = modules.data.find((e) => e.code_key === moduleKey);
        const startTime = new Date().getTime();
        setStartTime(startTime);
        setRecordId(params.id);
        setModuleId(module?.id);
      }
      setRoute(pathname)
    }
  };

  const sendPageViewAudit = async () => {
    try {
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/user_page_view`);
      await requests.post(getDataPost());
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }))
    }
  };

  const getModuleKey = () => {
    let locationPath = location.pathname.split('/');
    let customPaths = ['manual_verification', 'payment_processor_split', 'lead_buy_management', 'payment_schedule', 'report', 'send_email', 'wire_approval_queue', 'customer_merge_tool', 'promotion_code_customer'];
    if (locationPath[1] === 'user' && locationPath[2] === 'notification') {
      return 'custom_user_notification';
    } else if (customPaths.includes(locationPath[1])) {
      return 'custom_' + locationPath[1];
    } else {
      return locationPath[1];
    }
  };

  const getDataPost = () => {
    return {
      module_id: moduleId,
      record_id: recordId,
      spent_time: (new Date().getTime() - startTime) / 1000
    }
  }

  return null;
}
